// extracted by mini-css-extract-plugin
export default {"mainLoading":"styles_mainLoading__tdNgu"};